import { render, staticRenderFns } from "./orderDataStatistics.vue?vue&type=template&id=12531af8&scoped=true&"
import script from "./orderDataStatistics.vue?vue&type=script&lang=js&"
export * from "./orderDataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./orderDataStatistics.vue?vue&type=style&index=0&id=12531af8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12531af8",
  null
  
)

export default component.exports